import React from 'react';

const FloatingWhatsApp = () => {
  React.useEffect(() => {
    // eslint-disable-next-line no-console
    console.warn('Placeholder: FloatingWhatsApp is not implemented yet.');
  }, []);
  return (
    <>
  { /*FloatingWhatsApp */} 
 </>
  );
};

export default FloatingWhatsApp;
